<template>
  <div class="cont">
      
    <div class="progressbar">
      <div 
      class="progress-step progress-step-before progress-step-active"
       data-title="Paso 1"></div>
      <div class="progress-step  progress-step-before progress-step-active" data-title="Paso 2"></div>
      <div class="progress-step progress-step-before progress-step-active" data-title="Paso 3"></div>
      <div class="progress-step progress-step-before progress-step-active" data-title="Paso 4"></div>
      <div class="progress-step progress-step-active progress-step-active" :class="'!bg-btn-'+mainClass" data-title="Paso 5"></div>
      <div class="progress-step" data-title="Paso 6"></div>
      <div class="progress-step" data-title="Paso 7"></div>
    </div>
    <div class="form-step ">
        <div class="progress-step"></div>
    </div>
  </div>
</template>
<script>
export default {
    computed: {
        mainClass() {
          return process.env.VUE_APP_COLOR;
        }
      },
};
</script>

<style scoped lang="less">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
@media screen and (max-width: 480px) {
  .cont{
    margin-right: 7%;
  }
  .form-step {
    display: none;
  }
  .form-step-active {
    display: block;
  }

  .progressbar {
    margin-left: 5%;
    position: relative;
    display: flex;
    justify-content: space-between;
    counter-reset: step;
  }
  .progressbar::before {
    content: "";
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    height: 8%;
    width: 100%;
    background-color: #dcdcdc;
    z-index: -1;
  }
  .progress-step {
    width: 1.6875rem;
    height: 1.8875rem;
    background-color: #dcdcdc;
    border-radius: 50%;
    color: white;
    font-size: 82%;
  }
  .progress-step::before {
    counter-increment: step;
    content: counter(step);
  }
  .progress-step::after {
    font-family: "Montserrat";
     margin-right: -10%;
    margin-left: -8%;
    content: attr(data-title);
    position: absolute;
    top: calc(90% + 0.5rem);
    font-size: 0.8rem;
    color: #d3d3d3;
  }
  .progress-step-active:after {
    color: #000;
  }
  .progress-step-active {
    background-color: #822c30;

    color: white;
  }
  .progress-step-before{
   background-color: #000;
    
    
    color: white;

}
}
@media screen and (min-width: 481px) and (max-width: 760px) {
  .cont{
    margin-right: 9%;
  }
   .form-step {
    display: none;
  }
  .form-step-active {
    display: block;
  }

  .progressbar {
    margin-left: 10%;
    position: relative;
    display: flex;
    justify-content: space-between;
    counter-reset: step;
  }
  .progressbar::before {
    content: "";
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    height: 8%;
    width: 100%;
    background-color: #dcdcdc;
    z-index: -1;
  }
  .progress-step {
    width: 1.6875rem;
    height: 1.8875rem;
    background-color: #dcdcdc;
    border-radius: 50%;
    color: white;
    font-size: 82%;
  }
  .progress-step::before {
    counter-increment: step;
    content: counter(step);
  }
  .progress-step::after {
    font-family: "Montserrat";
     margin-right: -10%;
    margin-left: -8%;
    content: attr(data-title);
    position: absolute;
    top: calc(90% + 0.5rem);
    font-size: 0.9rem;
    color: #d3d3d3;
  }
  .progress-step-active:after {
    color: #000;
  }
  .progress-step-active {
    background-color: #822c30;
  }
  .progress-step-before{
   background-color: #000;
}

}
@media screen and (min-width: 761px) {
  .cont{
    margin-right: 7%;
  }

.form-step {
    display: none;
  }
  .form-step-active {
    display: block;
  }

  .progressbar {
    margin-left: 50%;
    position: relative;
    display: flex;
    justify-content: space-between;
    counter-reset: step;
  }
  .progressbar::before {
    content: "";
    position: absolute;
    top: 60%;
    transform: translateY(-50%);
    height: 8%;
    width: 100%;
    background-color: #dcdcdc;
    z-index: -1;
  }
  .progress-step {
    width: 1.6875rem;
    height: 1.8875rem;
    background-color: #dcdcdc;
    border-radius: 50%;
    color: white;
    font-size: 82%;
  }
  .progress-step::before {
    counter-increment: step;
    content: counter(step);
  }
  .progress-step::after {
    font-family: "Montserrat";
     margin-right: -10%;
    margin-left: -5%;
    content: attr(data-title);
    position: absolute;
    top: calc(90% + 0.5rem);
    font-size: 0.9rem;
    color: #d3d3d3;
  }
  .progress-step-active:after {
    color: #000;
  }
  .progress-step-active {
    background-color: #822c30;

    color: white;
  }
  .progress-step-before{
   background-color: #000;
}

}
</style>
